import { Analytics } from '../../api/analytics';
import { UserNotJoinedToPortal } from '../../notices/user-not-joined-to-portal';
import { useLoggingInStore } from '../../pinia/store';
import { RoutePaths } from '../../routing/route-paths';
import { OauthFailed } from '../../notices/oauth-failed';
import { mapWritableState } from 'ui.vue3.pinia';
import { UnknownPortal } from '../../notices/unknown-portal';
import { InviteCancelled } from '../../notices/invite-cancelled';
import { WrongInviteToken } from '../../notices/wrong-invite-token';
import { InvitesDisabled } from '../../notices/invites-disabled';
import { IncorrectInvite } from '../../notices/incorrect-invite';
import {
	UserRedirect,
	CONFIRMATION_SCENARIO_FIRST_AUTH,
} from 'b24network.vue.cross-scenario-shared-js';
import { UserEmailNotConfirmed } from '../../notices/user-email-not-confirmed';
import { InviteNotConfirmedByAdmin } from '../../notices/invite-not-confirmed-by-admin';
import { CantSendConfirmationEmail } from '../../notices/cant-send-confirmation-email';
import { BigIconType } from 'b24network.vue.base-components';
import {
	InviteNoticePage,
	InviteProcessingFailed,
	UserNotExistsOnPortal,
} from 'b24network.vue.invite-shared';

export const SignInNoticesShowing = {
	name: 'SignInNoticesShowing',

	components: {
		InviteNoticePage,
	},

	data(): Object
	{
		return {
			notYetAcceptedInvites: [],
		};
	},

	computed: {
		...mapWritableState(useLoggingInStore, [
			'login',
			'userNotice',
			'navigationButtonType',
		]),

		isInviteNotConfirmedByAdmin(): boolean
		{
			return this.userNotice instanceof InviteNotConfirmedByAdmin;
		},

		// When we only need to show some notice text and corresponding icon
		isSimpleNotice(): boolean
		{
			return this.userNotice instanceof InviteProcessingFailed
				|| this.userNotice instanceof OauthFailed
				|| this.userNotice instanceof UnknownPortal
				|| this.userNotice instanceof IncorrectInvite
				|| this.userNotice instanceof InviteCancelled
				|| this.userNotice instanceof WrongInviteToken
				|| this.userNotice instanceof InvitesDisabled
				|| this.userNotice instanceof CantSendConfirmationEmail
				|| this.isInviteNotConfirmedByAdmin
			;
		},

		isShowInviteLinks(): boolean
		{
			return this.userNotice instanceof UserNotJoinedToPortal;
		},

		simpleNoticeIconType(): string
		{
			if (
				this.userNotice instanceof UnknownPortal
				|| this.userNotice instanceof IncorrectInvite
				|| this.userNotice instanceof InviteCancelled
				|| this.userNotice instanceof WrongInviteToken
				|| this.userNotice instanceof InvitesDisabled
			)
			{
				return BigIconType.ERROR;
			}

			if (this.isInviteNotConfirmedByAdmin)
			{
				return BigIconType.EMAIL;
			}

			return BigIconType.WARNING;
		},

		isUnconfirmedEmailError(): boolean
		{
			return this.userNotice instanceof UserEmailNotConfirmed;
		},

		isUserNotExistsOnPortal(): boolean
		{
			return this.userNotice instanceof UserNotExistsOnPortal;
		},
	},

	methods: {
		onGoToMyB24Click(): void
		{
			Analytics.emitClickNotYourPortalGoToPortalList();
			UserRedirect.redirectToPortalList();
		},
	},

	mounted(): void
	{
		if (this.userNotice === null)
		{
			this.$router.replace(RoutePaths.SIGN_IN);
		}
		else if (this.isUnconfirmedEmailError)
		{
			this.login = this.userNotice.getUserAccount().toLogin();
			UserRedirect.redirectToConfirmationForm({
				subject: this.login,
				scenario: CONFIRMATION_SCENARIO_FIRST_AUTH,
			});

			return;
		}

		if (this.userNotice instanceof UserNotExistsOnPortal)
		{
			Analytics.emitShowUserNotExistsOnPortalPage();
		}

		if (this.userNotice instanceof UserNotJoinedToPortal)
		{
			this.notYetAcceptedInvites = this.userNotice.toNotYetAcceptedInvites();
		}

		this.navigationButtonType = 'change-account';
	},

	template: `
		<InviteNoticePage
			:user-notice="userNotice"
			:is-simple-notice="isSimpleNotice"
			:is-invite-not-confirmed-by-admin="isInviteNotConfirmedByAdmin"
			:is-show-invite-links="isShowInviteLinks"
			:simple-notice-icon-type="simpleNoticeIconType"
			:not-yet-accepted-invites="notYetAcceptedInvites"
			:is-show-portal-list-link="isUserNotExistsOnPortal"
			:portal-list-link-text="$Bitrix.Loc.getMessage('EXT_B24NET_LOGGING_IN_GO_TO_MY_B24')"
			@portal-list-link-click="onGoToMyB24Click"
		/>
	`,
};
